import { render } from "./PrizeTicketsModal.vue?vue&type=template&id=4dbf7ca7&scoped=true"
import script from "./PrizeTicketsModal.vue?vue&type=script&lang=js"
export * from "./PrizeTicketsModal.vue?vue&type=script&lang=js"

import "./PrizeTicketsModal.vue?vue&type=style&index=0&id=4dbf7ca7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbf7ca7"]])

export default __exports__